export const hotComments = [
  {
    id: 'c1',
    name: '吃瓜第一排',
    initial: '瓜',
    tag: '热评',
    time: '3 分钟前',
    text: '时间线整理得挺清楚，第四段的停车场画面确实把前面的疑问补上了，就等后续有没有更完整的一段。',
    likes: 1284,
    replies: 96,
  },
  {
    id: 'c2',
    name: '路过的老观众',
    initial: '路',
    tag: '高赞',
    time: '18 分钟前',
    text: '这种把素材按时间顺序排好的做法挺舒服的，比零散讨论好懂，希望编辑把来源也标注清楚一点。',
    likes: 863,
    replies: 42,
  },
  {
    id: 'c3',
    name: '隔壁吃瓜群众',
    initial: '隔',
    tag: '新',
    time: '34 分钟前',
    text: '我在同一个场子附近，当天人确实不少，不过拍摄角度有限，能确认的信息没有想象中那么多。',
    likes: 512,
    replies: 128,
  },
  {
    id: 'c4',
    name: '素材整理员',
    initial: '材',
    tag: '优质',
    time: '1 小时前',
    text: '聊天记录类投稿最好把完整对话一起发，只截一段很容易被误读，编辑核实起来也慢。',
    likes: 407,
    replies: 31,
  },
];